/**
 * Project timezone for all recruiter-facing date/time editing and display.
 *
 * Deadline/window columns are stored as UTC instants (`timestamptz`); the UI
 * always shows and edits them in this fixed zone so the wall-clock is identical
 * for every consultor regardless of their machine's local timezone.
 */
export const APP_TIMEZONE = 'America/Sao_Paulo';
